import React from "react";
import { createUseStyles, useTheme } from "react-jss";
const useStyles = createUseStyles((theme) => ({
  error: {
    color: theme.errormessageColor,
    fontSize: 10,
    width: "100%",
    textAlign: "center",
    display: "inline-block",
  },
}));
const ErrorMessage = ({ children }) => {
  const theme = useTheme();

  const styles = useStyles({ theme });
  return <div className={styles.error}>{children}</div>;
};

export { ErrorMessage };
